import React from 'react'
import { HowGoustoFoodBoxesWorkTypes } from '../../../../../types'
import {
  AlignItems,
  Body2,
  Box,
  Display,
  Heading3,
  Heading4,
  Icon,
  IconVariant,
  JustifyContent,
  Space,
} from '@gousto-internal/citrus-react'
import { OrderedCol } from '../OrderedCol'
import youInControlJpg from '../../assets/youincontrol.jpg'
import youInControlDesktopWebp from '../../assets/youincontrol-desktop.webp'
import youInControlMobileWebp from '../../assets/youincontrol-mobile.webp'

import { LandingPageButton } from '../../../../../components'
import { ResponsiveImage } from '../../../../../components/ResponsiveImage'
import { FoodBoxPageSections, TargetUri, TrackingActions } from '../../../../../types/tracking'

export function YouAreInControl({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <>
      <OrderedCol
        order={10}
        display={Display.Flex}
        alignItems={AlignItems.FlexStart}
        justifyContent={JustifyContent.Center}
      >
        <Box
          paddingRight={[null, null, null, 10]}
          maxWidth={[null, null, null, '600px']}
          width="100%"
        >
          <ResponsiveImage
            mobileWebp={youInControlMobileWebp}
            desktopWebp={youInControlDesktopWebp}
            fallbackSrc={youInControlJpg}
            style={{ maxHeight: '457px' }}
            fit="cover"
            alt="Variety of Gousto recipes, ranging from Prepped in 5, to global cuisines, to healthy recipes and family friendly."
          />
        </Box>
      </OrderedCol>
      <OrderedCol order={9}>
        <Heading3>You’re in Control</Heading3>
        <Space size={2} />
        <Box display={Display.Flex} paddingBottom={2}>
          <Box paddingRight={1}>
            <Icon name="tick" variant={IconVariant.Confirmation} data-testid="tick" />
          </Box>
          <Box>
            <Heading4 size={6}>Veggie or vegan?</Heading4>
            <Body2 size={4}>We’ve got options galore.</Body2>
          </Box>
        </Box>
        <Box display={Display.Flex} paddingBottom={2}>
          <Box paddingRight={1}>
            <Icon name="tick" variant={IconVariant.Confirmation} data-testid="tick" />
          </Box>
          <Box>
            <Heading4 size={6}>Feeding picky kids or hungry teens?</Heading4>
            <Body2 size={4}>Tuck into family-friendly faves.</Body2>
          </Box>
        </Box>
        <Box display={Display.Flex} paddingBottom={2}>
          <Box paddingRight={1}>
            <Icon name="tick" variant={IconVariant.Confirmation} data-testid="tick" />
          </Box>
          <Box>
            <Heading4 size={6}>Ingredient quality</Heading4>
            <Body2 size={4}>
              We partner with trusted suppliers for 100% British meat and responsibly sourced
              ingredients.
            </Body2>
          </Box>
        </Box>
        <Box display={Display.Flex} paddingBottom={2}>
          <Box paddingRight={1}>
            <Icon name="tick" variant={IconVariant.Confirmation} data-testid="tick" />
          </Box>
          <Box>
            <Heading4 size={6}>Cooking for one, two, or a whole hungry crew?</Heading4>
            <Body2 size={4}>Totally doable.</Body2>
          </Box>
        </Box>
        <Box display={Display.Flex} paddingBottom={4}>
          <Box paddingRight={1}>
            <Icon name="tick" variant={IconVariant.Confirmation} data-testid="tick" />
          </Box>
          <Box>
            <Heading4 size={6}>Plans that flex with your schedule and taste buds?</Heading4>
            <Body2 size={4}>Absolutely</Body2>
          </Box>
        </Box>
        <Box
          display={Display.Flex}
          justifyContent={[JustifyContent.Center, JustifyContent.FlexStart]}
          paddingBottom={[6, null, null, 0]}
        >
          <LandingPageButton
            startOnboarding={startOnboarding}
            sectionName={FoodBoxPageSections.CONTROL_SECTION}
            target={TargetUri.SIGNUP}
            action={TrackingActions.CLICK_GET_STARTED}
          >
            Get started with 50% off
          </LandingPageButton>
        </Box>
      </OrderedCol>
    </>
  )
}
